export default __webpack_public_path__ + "static/media/undraw_mobile_pay_re_sjb8.061946e5.svg";